<template>
    <form @submit.prevent="register" novalidate>
        <div
            v-if="errors.errorMessage()"
            v-html="errors.errorMessage()"
            class="form-error-message"
        ></div>

        <div class="form-group">
            <app-input
                :error="errors.get('email')"
                v-model="form.email"
                :label="$trans('auth.register.email_label')"
                :placeholder="$trans('auth.register.email_placeholder')"
            >
            </app-input>
        </div>

        <div class="form-group">
            <app-input
                :error="errors.get('password')"
                v-model="form.password"
                :type="passType"
                icon="eye"
                :icon-clickable="true"
                @click="togglePasswordType"
                :label="$trans('auth.register.password_label')"
                :placeholder="$trans('auth.register.password_placeholder')"
            >
            </app-input>
        </div>

        <div class="form-group">
            <app-input
                :error="errors.get('password_confirmation')"
                v-model="form.password_confirmation"
                type="password"
                :label="$trans('auth.register.password_confirm_label')"
                :placeholder="
                    $trans('auth.register.password_confirm_placeholder')
                "
            >
            </app-input>
        </div>

        <div class="form-group">
            <app-input
                :error="errors.get('first_name')"
                v-model="form.first_name"
                :label="$trans('auth.register.name_label')"
                :placeholder="$trans('auth.register.name_placeholder')"
            >
            </app-input>
        </div>

        <div class="form-group">
            <app-input
                :error="errors.get('last_name')"
                v-model="form.last_name"
                :label="$trans('auth.register.lastname_label')"
                :placeholder="$trans('auth.register.lastname_placeholder')"
            >
            </app-input>
        </div>

        <!--        <div class="form-group">-->
        <!--            <app-radio-buttons-->
        <!--                :label="$trans('auth.register.gender_label')"-->
        <!--                v-model="test"-->
        <!--                name="gender"-->
        <!--                :items="genderItems">-->
        <!--            </app-radio-buttons>-->
        <!--        </div>-->

        <div class="form-group">
            <vue-recaptcha
                ref="recaptchaRef"
                :show="1"
                size="normal"
                theme="light"
                :tabindex="0"
                @verify="recaptchaVerify"
                @expire="resetRecaptcha"
                :siteKey="app.keys.captcha"
            ></vue-recaptcha>
        </div>

        <div class="form-group">
            <app-checkbox
                v-model="form.terms"
                :label="$trans('auth.register.terms')"
            ></app-checkbox>
        </div>

        <div class="form-group flex-items submit-row">
            <div class="flex-item">
                <app-button
                    :loading="loading"
                    :disabled="!form.terms || !recaptcha"
                    type="submit"
                    >{{ $trans("auth.register.register_btn") }}</app-button
                >
            </div>
            <div class="flex-item">
                <a :href="app.links.login" class="existing-user">{{
                    $trans("auth.register.existing_user")
                }}</a>
            </div>
        </div>

        <div class="separator"></div>

        <div class="form-group">
            <div
                class="agreement-text"
                v-html="$trans('auth.terms_text')"
            ></div>
        </div>
    </form>
</template>

<script>
import vueRecaptcha from "vue3-recaptcha2";

export default {
    components: { vueRecaptcha },
    props: {
        isSpinToWin: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            errors: this.$api.errors(),
            loading: false,
            passType: "password",
            recaptcha: false,
            form: {
                email: "",
                password: "",
                password_confirmation: "",
                first_name: "",
                last_name: "",
                terms: false,
                is_from_spin_to_win: this.isSpinToWin
            },
            genderItems: [
                { name: this.$trans("auth.strings.male"), value: 0 },
                { name: this.$trans("auth.strings.female"), value: 1 }
            ]
        };
    },
    methods: {
        togglePasswordType() {
            this.passType = this.passType == "password" ? "text" : "password";
        },
        recaptchaVerify(response) {
            if (response) {
                this.recaptcha = true;
            }
        },
        resetRecaptcha() {
            this.$refs.recaptchaRef.reset();
            this.recaptcha = false;
        },
        async register() {
            this.loading = true;

            this.errors.clear();
            const response = await this.$api.post("auth/register", this.form);
            this.loading = false;

            if (response.hasErrors()) {
                this.errors = response.errors();
                return;
            }

            if (response.data().redirect) {
                window.location.href = response.data().redirect;
            }
        }
    }
};
</script>
